import * as S from "./styles";

export type IInputContainerProps = {
  label: string;
  required?: boolean;
  children?: React.ReactNode;
};

export const InputContainer = ({
  label,
  required,
  children,
}: IInputContainerProps) => {
  return (
    <S.InputContainer>
      <span>
        {label}
        {required && <span id="required-label">*</span>}
      </span>
      <div>{children}</div>
    </S.InputContainer>
  );
};
